export default "__VITE_ASSET__DtSYLDvX__"